import React, { useState, useEffect } from 'react';
import CTASection from '../components/CTASection';
import ThinkDreamSection from '../components/ThinkDreamSection';
import '../styles/ProductIdeate.css';
import '../styles/Home.css';
import UIIdeas from '../components/UIIdeas';
const ProductBrainstorm = () => {
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [nextQuoteIndex, setNextQuoteIndex] = useState(1);

  const quotes = [
    "“I hate that I love you.”", // User will add these
    "“Show me the money!”",
    "“Here’s looking at you, kid.”",
    "“I’m having an old friend for dinner.”",
    "“To infinity and beyond!”",
    "“Life finds a way.”",
    "“Get in, loser. We’re going shopping.”"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setCurrentQuoteIndex((prevIndex) => {
        const next = (prevIndex + 1) % quotes.length;
        setNextQuoteIndex(next);
        return prevIndex; // Keep current index for exit animation
      });
      setTimeout(() => {
        setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        setIsAnimating(false);
      }, 1500); // Animation duration
    }, 3000);

    return () => clearInterval(interval);
  }, [quotes.length]);
  return (
    <div className="product-page">
      <section
        className="hero product-page-hero">
        <div className="container">

        <label>Ideate</label>
          <h1 className="hero-title title-wide ideate-title">Ideas, thoughts and everything in between</h1>
          <p className="hero-subtitle subtitle-wide ideate-title">
          Jot down ideas, chirps of dialogue and sudden sparks of genius. 
          </p>
          <div className="star-wrapper">
          <svg width="655" height="655" viewBox="0 0 655 655" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M411.755 173.156C419.048 177.157 421.717 186.313 417.715 193.607L357.769 302.861L477.411 267.995C485.398 265.668 493.759 270.255 496.087 278.242C498.414 286.229 493.827 294.59 485.84 296.917L366.446 331.711L475.38 391.481C482.673 395.483 485.342 404.639 481.34 411.933C477.338 419.226 468.182 421.894 460.888 417.892L352.184 358.248L386.875 477.29C389.203 485.276 384.615 493.637 376.629 495.964C368.642 498.292 360.281 493.704 357.954 485.717L323.087 366.072L263.141 475.327C259.139 482.621 249.982 485.289 242.689 481.288C235.396 477.286 232.728 468.13 236.73 460.836L296.374 352.132L177.332 386.823C169.345 389.151 160.984 384.563 158.657 376.576C156.329 368.59 160.917 360.229 168.904 357.901L288.193 323.137L179.168 263.317C171.875 259.316 169.206 250.16 173.208 242.866C177.21 235.573 186.365 232.905 193.659 236.907L302.914 296.853L268.047 177.21C265.72 169.224 270.307 160.863 278.294 158.535C286.281 156.207 294.642 160.795 296.969 168.782L331.66 287.821L391.304 179.115C395.306 171.822 404.462 169.154 411.755 173.156Z" fill="#FF6344"/>
</svg>
          </div>
        </div>
      </section>

<UIIdeas selectedTab="ideas" pageClassName="ui-ideas-product-ideate" />

<div className="divider"></div>
    
<section className="section-marg two-column-section mt-112">
        <div className="two-column-container">
          <div className="two-column-item">
            <label>Scripts</label>
            <h2 className="section-title">Study the greats</h2>
            <p className="section-subtitle">Dive into the Script Slug catalogue and study the greats, with hundreds of links right inside Fiktion.</p>
            <div className="grey">
              <div className="script-links">
              <a className="script-link flex space-between" href="https://assets.scriptslug.com/live/pdf/scripts/michael-clayton-2007.pdf?v=1729114952" target="_blank" rel="noopener noreferrer">
                <div className="flex gap-4 flex-column">
                  <p>Michael Clayton</p>
                  <span>Academy Award Nominee for Best Writing, Original Screenplay</span>
                  </div>
                  <div className="script-link-icon">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5H7C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V12.5" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 10L15 5M15 5V9.16667M15 5H10.8333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  </div>
                </a>
              <a className="script-link flex space-between" href="https://assets.scriptslug.com/live/pdf/scripts/alien-1979.pdf?v=1729114856" target="_blank" rel="noopener noreferrer">
                <div className="flex gap-4 flex-column">
                  <p>Alien</p>
                  <span>Top rated movie #49 on IMDb with 1 million votes.</span>
                  </div>
                  <div className="script-link-icon">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5H7C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V12.5" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 10L15 5M15 5V9.16667M15 5H10.8333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  </div>
                </a>
                <a className="script-link flex space-between" href="https://assets.scriptslug.com/live/pdf/scripts/the-social-network-2010.pdf?v=1729115039" target="_blank" rel="noopener noreferrer">
                <div className="flex gap-4 flex-column">
                  <p>The Social Network</p>
                  <span>Academy Award Winner for Best Writing, Adapted Screenplay</span>
                  </div>
                  <div className="script-link-icon">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5H7C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V12.5" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 10L15 5M15 5V9.16667M15 5H10.8333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  </div>
                </a>
                <a className="script-link flex space-between" href="https://assets.scriptslug.com/live/pdf/scripts/american-beauty-1999.pdf?v=1729114858" target="_blank" rel="noopener noreferrer">
                  <div className="flex gap-4 flex-column">
                    <p>American Beauty</p>
                    <span>Academy Award Winner for Best Writing, Screenplay Written Directly for the Screen</span>
                  </div>
                  <div className="script-link-icon">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 5H7C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V12.5" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M10 10L15 5M15 5V9.16667M15 5H10.8333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
                <a className="script-link flex space-between" href="https://assets.scriptslug.com/live/pdf/scripts/up-in-the-air-2009.pdf?v=1729115056" target="_blank" rel="noopener noreferrer">
                <div className="flex gap-4 flex-column">
                  <p>Up in the Air</p>
                  <span>Academy Award Nominee for Best Writing, Adapted Screenplay</span>
                  </div>
                  <div className="script-link-icon">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5H7C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V12.5" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 10L15 5M15 5V9.16667M15 5H10.8333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  </div>
                </a>

                <a className="script-link flex space-between" href="https://assets.scriptslug.com/live/pdf/scripts/up-in-the-air-2009.pdf?v=1729115056" target="_blank" rel="noopener noreferrer">
                <div className="flex gap-4 flex-column">
                  <p>A Real Pain</p>
                  <span>Academy Award Winner Best Original Screenplay</span>
                  </div>
                  <div className="script-link-icon">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5H7C5.89543 5 5 5.89543 5 7V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V12.5" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 10L15 5M15 5V9.16667M15 5H10.8333" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="two-column-divider"></div>
          <div className="two-column-item">
          <label>Quotes</label>
            <h2 className="section-title">You had me at 'hello'</h2>
            <p className="section-subtitle">From whispered lines to legendary monologues, let cinema’s greatest words inspire your own with Fiktion's quote library.</p>
            <div className="grey items-center justify-center">
              <div className="quote-animation-container">
                {!isAnimating && (
                  <div 
                    key={currentQuoteIndex}
                    className="quote-text quote-visible"
                  >
                    {quotes[currentQuoteIndex]}
                  </div>
                )}
                {isAnimating && (
                  <>
                    <div 
                      key={`exit-${currentQuoteIndex}`}
                      className="quote-text quote-exit"
                    >
                      {quotes[currentQuoteIndex]}
                    </div>
                    <div 
                      key={`enter-${nextQuoteIndex}`}
                      className="quote-text quote-enter"
                    >
                      {quotes[nextQuoteIndex]}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      <ThinkDreamSection />

      <div className="divider"></div>

      <CTASection />
    </div>
  );
};

export default ProductBrainstorm;
